/**
 * @file: erpProviderLogo.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ErpProviderId } from '@euler/model/enum';
import { ErpProviderInfo } from '@euler/model/erp-integrations';
import { ImageSourcePropType } from 'react-native';

/**
 * Logos bundled with the app, keyed by provider. Used when the catalog entry
 * carries no `logo` URL — which is every provider today. A provider missing
 * from here is not an error: callers fall back to a lettermark.
 */
const kBundledLogos: Partial<Record<ErpProviderId, ImageSourcePropType>> = {
  [ErpProviderId.Casstime]: require('../assets/logos/casstime.png'),
  [ErpProviderId.F6]: require('../assets/logos/f6.png'),
  [ErpProviderId.Gyyrkj]: require('../assets/logos/gyyrkj.png'),
  [ErpProviderId.Heigu]: require('../assets/logos/heigu.png'),
  [ErpProviderId.Sihui]: require('../assets/logos/sihui.png'),
  [ErpProviderId.T9090]: require('../assets/logos/t9090.png'),
  [ErpProviderId.Zhongtukj]: require('../assets/logos/zhongtukj.png'),
};

/** The server's logo wins; the bundled copy is the offline fallback. */
export const getErpProviderLogoSource = (
  provider?: ErpProviderInfo,
): ImageSourcePropType | undefined => {
  if (!provider) return undefined;
  if (provider.logo) return { uri: provider.logo };
  return kBundledLogos[provider.providerId];
};
